const defaultVisibilitySettings = {
    'projects': {
        'assignments': {
            'graph': 'pipelineGraph',
            'infoPanelSettings': {
                'overview': {
                    'general': {
                        'label': null,
                        'visible': true,
                        'fields': {
                            'name': true,
                            'client': true,
                            'startDate': true,
                            'endDate': true,
                            'industry': true,
                            'career': true,
                            'description': true,
                            'owner': true,
                            'projectId': true,
                            'source': true,
                        },
                    },
                    'connect-link': {
                        'label': null,
                        'visible': true,
                    },
                    'compensation': {
                        'label': null,
                        'visible': true,
                    },
                    'potential': {
                        'label': null,
                        'visible': true,
                    },
                    'mandatory-custom-fields': {
                        'label': null,
                        'visible': true,
                    },
                    'archive': {
                        'label': null,
                        'visible': true,
                    },
                },
            },
            'icons': {
                'statusHeart': true,
                'relationships': true,
                'notifyMe': true,
                'download': true,
                'clientPortal': true,
                'convertModel': false,
            },
            'tabs': {
                'info': true,
                'custom': true,
                'owners': true,
                'candidates': true,
                'actions': true,
                'unconnected': true,
                'search': true,
                'target': true,
                'contacts': true,
                'billing': true,
                'journal': true,
                'notes': true,
                'tasks': true,
                'meetings': true,
                'attachments': true,
                // 'related': true,
                'relationships': true,
                'clientPortal': true,
            },
        },
        'opportunities': {
            'graph': 'probabilityGraph',
            'infoPanelSettings': {
                'overview': {
                    'general': {
                        'label': null,
                        'visible': true,
                        'fields': {
                            'name': true,
                            'client': true,
                            'projectId': true,
                            'startDate': true,
                            'endDate': true,
                            'industry': true,
                            'career': true,
                            'description': true,
                            'owner': true,
                            'source': true,
                        },
                    },
                    'connect-link': {
                        'label': null,
                        'visible': true,
                    },
                    'compensation': {
                        'label': null,
                        'visible': true,
                    },
                    'potential': {
                        'label': null,
                        'visible': true,
                    },
                    'mandatory-custom-fields': {
                        'label': null,
                        'visible': true,
                    },
                    'archive': {
                        'label': null,
                        'visible': true,
                    },
                },
            },
            'icons': {
                'statusHeart': true,
                'relationships': true,
                'notifyMe': true,
                'download': true,
                'clientPortal': true,
                'convertModel': false,
            },
            'tabs': {
                'info': true,
                'custom': true,
                'owners': true,
                'candidates': true,
                'actions': true,
                'unconnected': true,
                'search': true,
                'target': true,
                'contacts': true,
                'billing': true,
                'journal': true,
                'notes': true,
                'tasks': true,
                'meetings': true,
                'attachments': true,
                // 'related': true,
                'relationships': true,
                'clientPortal': true,
            },
        },
        'lists': {
            'graph': 'tasksGraph',
            'infoPanelSettings': {
                'overview': {
                    'general': {
                        'label': null,
                        'visible': true,
                        'fields': {
                            'name': true,
                            'client': true,
                            'startDate': true,
                            'endDate': true,
                            'industry': true,
                            'career': true,
                            'description': true,
                            'owner': true,
                            'projectId': true,
                            'source': true,
                        },
                    },
                    'connect-link': {
                        'label': null,
                        'visible': true,
                    },
                    'compensation': {
                        'label': null,
                        'visible': true,
                    },
                    'potential': {
                        'label': null,
                        'visible': true,
                    },
                    'mandatory-custom-fields': {
                        'label': null,
                        'visible': true,
                    },
                    'archive': {
                        'label': null,
                        'visible': true,
                    },
                },
            },
            'icons': {
                'statusHeart': true,
                'relationships': true,
                'notifyMe': true,
                'download': true,
                'clientPortal': true,
                'convertModel': true,
            },
            'tabs': {
                'info': true,
                'custom': true,
                'owners': true,
                'people': true,
                'actions': true,
                'unconnected': true,
                'search': true,
                'target': true,
                'contacts': true,
                'billing': true,
                'journal': true,
                'notes': true,
                'tasks': true,
                'meetings': true,
                'attachments': true,
                // 'related': true,
                'relationships': true,
                'clientPortal': true,
            },
        },
    },
    'people': {
        'infoPanelSettings': {
            'overview': {
                'contact-info': {
                    'label': null,
                    'visible': true,
                    'fields': {
                        'title': true,
                        'first-name': true,
                        'last-name': true,
                        'headline': true,
                        'summary': true,
                        'address': true,
                        'website': true,
                        'phone-number': true,
                    },
                    'integration': {
                        'profile-tags': true,
                        'linkedin': true,
                        'cv-import': true,
                        'nal-tag': true,
                    },
                },
                'positions': {
                    'label': null,
                    'visible': true,
                },
                'current-status': {
                    'label': null,
                    'visible': true,
                },
                'aspirations': {
                    'label': null,
                    'visible': true,
                },
                'confidential-info': {
                    'label': null,
                    'visible': true,
                },
                'qualifications': {
                    'label': null,
                    'visible': true,
                },
                'languages': {
                    'label': null,
                    'visible': true,
                },
            },
        },
        'icons': {
            'merge-duplicates': true,
            'offlimit-agreement': true,
            'notify-me': true,
            'download': true,
            'ms-contacts': true,
        },
        'tabs': {
            'info.person-info': true,
            'custom': true,
            'owners': true,
            'boardex': true,
            'altrata': true,
            'lists': true,
            'opportunities': true,
            'assignments': true,
            'companies': true,
            'journal': true,
            'notes': true,
            'emails.person-emails': true,
            'tasks': true,
            'meetings': true,
            'attachments': true,
            'forms.person-forms': true,
            'relationships': true,
            'similar': true,
        },
    },
    'companies': {
        'infoPanelSettings': {
            'overview': {
                'general': {
                    'label': null,
                    'visible': true,
                    'fields': {
                        'name': true,
                        'division': true,
                        'phone': true,
                        'email': true,
                        'size': true,
                        'specialities': true,
                        'description': true,
                        'industries': true,
                    },
                },
                'addresses': {
                    'label': null,
                    'visible': true,
                },
                'archive': {
                    'label': null,
                    'visible': true,
                },
            },
        },
        'icons': {
            'offlimit-agreement': true,
            'target': true,
            'notify-me': true,
            'ms-contacts': true,
        },
        'tabs': {
            'info.companies-info-panel': true,
            'custom': true,
            'owners': true,
            'links': true,
            'boardex': true,
            'altrata': true,
            'assignments': true,
            'opportunities': true,
            'lists': true,
            'contacts': true,
            'journal': true,
            'notes': true,
            'tasks': true,
            'meetings': true,
            'attachments': true,
            //'related': true,
            'relationships': true,
        },
    },
    'tabLabels': {
        'info': null,
        'custom': null,
        'people': null,
        'candidates': null,
        'unconnected': null,
        'target': null,
        'search': null,
        'billing': null,
        'contacts': null,
        'notes': null,
        'emails': null,
        'tasks': null,
        'meetings': null,
        'attachments': null,
        // 'related': null,
        'links': null,
        'boardex': null,
        'altrata': null,
        'person-lists': null,
        'person-assignments': null,
        'person-opportunities': null,
        'company-lists': null,
        'company-assignments': null,
        'company-opportunities': null,
        'companies': null,
        'forms': null,
        'list-people': null,
        'assignment-candidates': null,
        'opportunity-candidates': null,
        'similar': null,
        'actions': null,
        'relationships': null,
        'owners': null,
    },
};
const dashboardChartKey = {
    'assignments': 'candidates',
    'opportunities': 'potential',
    'lists': 'people',
};
const dashboardContentKeys = {
    'nextTask': 'tasks',
    'nextMeeting': 'meetings',
    'revenue': 'billing',
    'weightedRevenue': 'billing',
    'notice': 'confidential-info',
    'salary': 'confidential-info',
    'email': 'emails.person-emails',
};

const mandatorySettingsFieldKeys = {
    'projects': [
        'insights',
        'info',
        'custom',
        'owners',
        'notes',
        'general',
        'mandatory-custom-fields',
    ],
    'people': [
        'insights',
        'info.person-info',
        'custom',
        'notes',
        'contact-info',
        'positions',
        'owners',
    ],
    'companies': [
        'insights',
        'info.companies-info-panel',
        'custom',
        'notes',
        'general',
        'owners',
    ],
};

const mandatoryFieldsKeyMappings = {
    // For Project Types mapping format not needed atm
    people: {
        email: 'emails.person-emails',
    },
    companies: {
        addresses: 'addresses',
    },
};

const sharedSettings = {
    tasks: 'tasks',
    connect: 'candidates',
    billing: 'billing',
};

const cpKeyMappings = {
    'positions': 'positions',
    'current-status': 'currentStatus',
    'aspirations': 'aspirations',
    'confidential-info': 'confidential',
    'qualifications': 'education',
    'languages': 'languages',
};

const hideableLinkedTabs = {
    'people': {
        'profile-positions': 'positions',
        'tasks': 'tasks',
    },
    'companies': {
        'tasks': 'tasks',
    },
};

const projectTypeButtonConfigs = {
    assignments: {
        permissionGroup: 'candidates',
        icon: 'fal fa-list-ul',
    },
    opportunities: {
        permissionGroup: 'candidates',
        icon: 'fal fa-percent',
    },
    lists: {
        permissionGroup: 'people',
        icon: 'fal fa-folder-user',
    },
};

const customFieldCandidatesMappings = {
    'current': 'current-status',
    'positions': 'positions',
    'aspirations': 'aspirations',
    'languages': 'languages',
    'confidential': 'confidential-info',
    'qualifications': 'qualifications',

};

const wordReportMappings = {
    'candidate-report': {
        'candidate-email': 'emails.person-emails',
        'candidate-current': 'current-status',
        'candidate-aspirations': 'aspirations',
        'candidate-positions': 'positions',
        'candidate-edu': 'qualifications',
        'candidate-confidential': 'confidential-info',
        'candidate-lang': 'languages',
    },
    'project-report': {
        'projects': {
            'candidate-count': 'candidates',
            'project-tags': 'candidates',
            'meetings': 'meetings',
            'tasks': 'tasks',
            'target-companies': 'target',
            'candidates': 'candidates',
            'candidate-target': 'target',
        },
        'people': {
            'candidate-email': 'emails.person-emails',
            'candidate-first-company': 'positions',
            'candidate-first-title': 'positions',
            'candidate-current': 'current-status',
            'candidate-aspirations': 'aspirations',
            'candidate-positions': 'positions',
            'candidate-edu': 'qualifications',
            'candidate-confidential': 'condidential-info',
            'candidate-lang': 'languages',
        },
    },
};

const excelReportMappings = {
    'candidate-report': {
        'reportkeys.current-info': 'current-status',
        'reportkeys.candidate-confidential': 'confidential-info',
        'reportkeys.candidate-aspirations': 'aspirations',
        'reportkeys.spoken-languages': 'languages',
        'reportkeys.candidate-email': 'emails.person-emails',
        'reportkeys.candidate-positions-classic': 'positions',
        'reportkeys.candidate-positions-latest': 'positions',
        'reportkeys.candidate-positions-chronological': 'positions',
        'reportkeys.candidate-edu-classic': 'qualifications',
        'reportkeys.candidate-edu-latest': 'qualifications',
        'reportkeys.candidate-edu-chronological': 'qualifications',
    },
    'project-report': {
        'projects': {
            'statuses': 'candidates',
            'reportkeys.target-company-searches': 'target',
            'reportkeys.upcoming': 'meetings',
            'reportkeys.past': 'meetings',
            'reportkeys.active': 'tasks',
            'reportkeys.completed': 'tasks',
            'reportkeys.candidates': 'candidates',
        },
        'people': {
            'reportkeys.current-info': 'current-status',
            'reportkeys.candidate-confidential': 'condidential-info',
            'reportkeys.candidate-aspirations': 'aspirations',
            'reportkeys.spoken-languages': 'languages',
            'reportkeys.candidate-email': 'emails.person-emails',
            'reportkeys.candidate-positions-classic': 'positions',
            'reportkeys.candidate-positions-latest': 'positions',
            'reportkeys.candidate-positions-chronological': 'positions',
            'reportkeys.candidate-edu-classic': 'qualifications',
            'reportkeys.candidate-edu-latest': 'qualifications',
            'reportkeys.candidate-edu-chronological': 'qualifications',
        },
    },
    'general-report': {
        'all': {
            'reportkeys.tasks': 'tasks',
            'reportkeys.meetings': 'meetings',
            'reportkeys.tasksCount': 'tasks',
            'reportkeys.meetingsCount': 'meetings',
            'reportkeys.emailsCount': 'emails.person-emails',
            ':tasksCount[]': 'tasks',
            ':meetingsCount[]': 'meetings',
            ':emailsCount[]': 'emails.person-emails',
        },
        'projects': {
            'reportkeys.projectedRevenue': 'billing',
            'reportkeys.bookedRevenue': 'billing',
        },
        'lists': {
            'common.leads': 'people',
            'reportkeys.leadsCount': 'people',
        },
        'assignments': {
            'statuses': 'candidates',
            'nal-lang.excel.cand-count': 'candidates',
            'nal-lang.excel.salary.range': 'compensation',
            'nal-lang.excel.salary.min': 'compensation',
            'nal-lang.excel.salary.max': 'compensation',
            'reportkeys.assignment-revenue': 'billing',
        },
        'companies': {
            'reportkeys.address-oneLine': 'addresses',
            'reportkeys.address-multipleLines': 'addresses',
        },
        'people': {
            'reportkeys.current-info': 'current-status',
            'reportkeys.candidate-confidential': 'condidential-info',
            'reportkeys.candidate-aspirations': 'aspirations',
            'reportkeys.candidate-email': 'emails.person-emails',
            'reportkeys.candidate-positions-classic': 'positions',
            'reportkeys.candidate-edu-classic': 'qualifications',
            'reportkeys.outlookEmails': 'emails.person-emails',
        },
    },
};

const powerpointReportMappings = {
    'person-report': {
        'candidate-email': 'emails.person-emails',
        'current-position': 'current-status',
        'candidate-aspirations': 'aspirations',
        'candidate-positions': 'positions',
        'candidate-edu': 'qualifications',
        'candidate-lang': 'languages',
        'candidate-confidential': 'condidential-info',
    },
    'project-report': {
        'projects': {
            'meetings': 'meetings',
            'tasks': 'tasks',
            'project-compensation': 'compensation',
            'pipeline-tags': 'candidates',
            'target-companies': 'target',
        },
        'people': {
            'candidate-email': 'emails.person-emails',
            'current-position': 'current-status',
            'candidate-aspirations': 'aspirations',
            'candidate-positions': 'positions',
            'candidate-edu': 'qualifications',
            'candidate-lang': 'languages',
            'candidate-confidential': 'condidential-info',
        },
    },
};

const spreadsheetMappings = {
    'all': {
        'manage-person.tasks': 'tasks',
    },
    'projects': {
        'billing.header': 'billing',
        'billing.invoices.column': 'billing',
        'billing.invoice-items.header': 'billing',
        'billing.revenues.column': 'billing',
        'billing.fee-splits.header': 'billing',
        'billing.fixed-fees.column': 'billing',
        'billing.entity.header': 'billing',
        'billing.contact.header': 'billing',
    },
    'assignments': {
        'Compensation': 'compensation',
        'Compensation Minimum': 'compensation',
        'Compensation Maximum': 'compensation',
        'Compensation Currency': 'compensation',
        'ID: Assignment Contact 1-3': 'contacts',
        'Assignment Contact 1-3': 'contacts',
        'Assignment Contact Role 1-3': 'contacts',
        'Assignment Contact Email 1-3': 'contacts',
    },
    'people': {
        'contact-details.emails': 'emails.person-emails',
        'candidate.qualifications': 'qualifications',
        'candidate.languages': 'languages',
        'manage-person.tasks': 'tasks',
    },
};

const reportKeyMappings = {
    'word': wordReportMappings,
    'excel': excelReportMappings,
    'powerpoint': powerpointReportMappings,
    'spreadsheet': spreadsheetMappings,
};

export {
    defaultVisibilitySettings,
    dashboardChartKey,
    dashboardContentKeys,
    mandatorySettingsFieldKeys,
    mandatoryFieldsKeyMappings,
    sharedSettings,
    cpKeyMappings,
    hideableLinkedTabs,
    projectTypeButtonConfigs,
    customFieldCandidatesMappings,
    reportKeyMappings,
};